import { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { OLAF, PANTERA } from 'HubStyleTokens/colors';
import { TOOLBAR_HEIGHT_DARK } from 'HubStyleTokens/sizes';
import EPNavigationDropdown from 'editor-components/header/EPNavigationDropdown';
import EPNavigationItem from 'editor-components/header/EPNavigationItem';
import UIList from 'UIComponents/list/UIList';
import OutsideClickListener from 'editor-components/OutsideClickListener';
import { jsx as _jsx } from "react/jsx-runtime";
const NavigationBar = styled.nav.withConfig({
  displayName: "EPNavigationBar__NavigationBar",
  componentId: "pg2s3o-0"
})(["font-size:13px;font-weight:500;white-space:nowrap;text-decoration:none;-webkit-font-smoothing:antialiased;box-sizing:content-box;height:", ";width:100%;a,a:hover{color:", ";text-decoration:none;}a{display:flex;align-items:center;}.primary-links{padding:0;margin:0;}.uiListItem{transition:all 0.15s ease-out;text-shadow:0 0 1px transparent;position:relative;cursor:pointer;padding:0;}.uiListItem:hover,.uiListItem:focus{background-color:", ";}.uiListItem > a{padding:0 1em;line-height:", ";}"], TOOLBAR_HEIGHT_DARK, OLAF, PANTERA, TOOLBAR_HEIGHT_DARK);
const EPNavigationBar = ({
  navigationGroups,
  onActiveItemChange,
  shouldClear
}) => {
  const [activeItem, setActiveItem] = useState('');
  const handleSetActiveItem = useCallback(id => {
    setActiveItem(id);
  }, []);
  const clearActiveItem = useCallback(() => {
    setActiveItem('');
  }, []);
  const handleOutsideClick = useCallback(e => {
    e.stopPropagation();
    clearActiveItem();
  }, [clearActiveItem]);
  useEffect(() => {
    if (shouldClear) {
      clearActiveItem();
    }
  }, [clearActiveItem, shouldClear]);
  useEffect(() => {
    if (onActiveItemChange) {
      onActiveItemChange(activeItem);
    }
  }, [activeItem, onActiveItemChange]);
  return /*#__PURE__*/_jsx(OutsideClickListener, {
    onOutsideClick: handleOutsideClick,
    children: /*#__PURE__*/_jsx(NavigationBar, {
      "data-onboarding": "ep-navigation-bar",
      "data-campaign-assistant-onboarding-tour": "tour-step-navigation",
      role: "navigation",
      children: /*#__PURE__*/_jsx(UIList, {
        inline: true,
        className: "primary-links",
        children: navigationGroups.map(navigationGroup => {
          if (navigationGroup !== null && navigationGroup !== void 0 && navigationGroup.hideLink) {
            return null;
          }
          if (navigationGroup && 'children' in navigationGroup) {
            return /*#__PURE__*/_jsx(EPNavigationDropdown, {
              activeItem: activeItem,
              clearActiveItem: clearActiveItem,
              setActiveItem: handleSetActiveItem,
              navGroup: navigationGroup
            }, navigationGroup.id);
          } else if (navigationGroup) {
            return /*#__PURE__*/_jsx(EPNavigationItem, {
              navItem: navigationGroup
            }, navigationGroup.id);
          } else {
            return null;
          }
        })
      })
    })
  });
};
EPNavigationBar.propTypes = {
  navigationGroups: PropTypes.array.isRequired,
  onActiveItemChange: PropTypes.func,
  shouldClear: PropTypes.bool
};
export default EPNavigationBar;